(function () {
    'use strict';

    angular
        .module('adm')
        .config(AdmRoute);

    AdmRoute.$inject = ['$stateProvider'];

    /* @ngInject */
    function AdmRoute ($stateProvider) {
        $stateProvider
            .state('root.adm', {
                abstract: true,
                url: '/adm',
                resolve: {
                    /* Inserir as regras de Acl aqui! */
                }
            });
    }
})();